import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import styles from './WhiteContainer.module.scss';

type WhiteContainerProps = {
	children: ReactNode;
	title: string;
	subtitle?: string;
	parentClassName?: string;
};

const WhiteContainer: FC<WhiteContainerProps> = ({
	children,
	title,
	subtitle,
	parentClassName,
}: WhiteContainerProps) => {
	return (
		<div className={cx(styles.main, parentClassName && parentClassName)}>
			<h1 className={cx('title', styles.title)}>{title}</h1>
			{subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
			{children}
		</div>
	);
};

export default WhiteContainer;
